import styled from "styled-components";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import { useDevice } from "../../../common/hooks/useDevice";
import WorkingRateTrendChartCard from "./WorkingRateTrendChartCard";
import UserRoleDashboardCard from "./UserRoleDashboardCard";
import { Column, SizedBox } from "../../../common/components/CommonBaseComponents";
import TopTenUsageDashboardCard from "./TopTenUsageDashboardCard";

const BottomTextCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 100%;
    gap: 17px;
`;

function AdminDashboardBottomArea() {
    const { width } = useWindowSize();
    const currentDevice = useDevice();

    if (currentDevice === "tablet" || width <= 1970) {
        return (
            <Column width={"100%"}>
                <WorkingRateTrendChartCard />
                <SizedBox height={"16px"} />
                <TopTenUsageDashboardCard />
                <SizedBox height={"16px"} />
                <UserRoleDashboardCard />
            </Column>
        );
    } else {
        return (
            <BottomTextCardGrid>
                <Column width={"100%"}>
                    <WorkingRateTrendChartCard />
                    <SizedBox height={"16px"} />
                    <TopTenUsageDashboardCard />
                </Column>
                <UserRoleDashboardCard />
            </BottomTextCardGrid>
        );
    }
}

export default AdminDashboardBottomArea;
